
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.157 4.353a.586.586 0 00-.782.874A5.07 5.07 0 0117.062 9a5.07 5.07 0 01-1.687 3.773.586.586 0 10.782.873A6.244 6.244 0 0018.233 9c0-1.771-.757-3.465-2.078-4.647zM11.265 1.26a.586.586 0 00-.611.05L6.1 4.648H1.586A.586.586 0 001 5.234v7.531c0 .324.262.586.586.586H6.1l4.552 3.339a.585.585 0 00.933-.473V1.782a.586.586 0 00-.321-.522zm-.85 13.8l-3.776-2.767a.586.586 0 00-.346-.114H2.172V5.82h4.121c.125 0 .246-.039.346-.112l3.775-2.768V15.06z","fill":"currentColor","stroke":"currentColor"}})])
          )
        }
      }
    